export const MAX_MENU_HEIGHT = 560;
export const MAX_ITEMS_SHOW = 10;
export const DEFAULT_DELETE_ICON_COLOR = '#EB5757';
